import {max} from './max';

export const findHeaviestPathInTree = <T>(
  root: T,
  isLeaf: (node: T) => boolean,
  getBranches: (node: T) => T[],
  getWeight: (node: T) => number
): { currentWeight: number; branches: T[] } => {
  if (!isLeaf(root)) {
    const longestBranch = getBranches(root).map((branch: T) => {
      return findHeaviestPathInTree(branch, isLeaf, getBranches, getWeight);
    });
    const sectionWithLongestPath = max(longestBranch, (branch) => branch.currentWeight);
    return {
      currentWeight: getWeight(root) + sectionWithLongestPath.currentWeight,
      branches: [root, ...sectionWithLongestPath.branches],
    };
  }

  return {
    currentWeight: getWeight(root),
    branches: [root],
  };
};
